<div class="app-footer">
  <div class="app-footer__inner">
    <div class="col-md-2">
      Copyright © 2019
    </div>
    <div class="col-md-3 text-center">
      <a href="http://www.herainfor.com.br" target="_blank" class="pl-2">HERA Consultoria em Sistemas de Informação</a>
    </div>
    <div class="col-md-3 text-center text-primary">
      <span class="pl-5">Licenciado para {{ this.nomeCliente}}</span>
    </div>
    <div class="col-md-3 text-center text-primary">
      <span class="pl-5">{{ this.parceiroComercial}}</span>
    </div>
    <div class="col-md-1 text-right">
      versão 1.0.0.0
    </div>
  </div>
</div>